import url from 'url';
import {SITES} from './sites';

const badlyEncode = (s) => encodeURIComponent(s).replace(/%20/g, '+');

const encodeParams = (params) =>
    Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&');

const encodeQueryPair = (query, key) =>
    `${badlyEncode(key)}:${badlyEncode(query[key])}`;

const encodeQuery = (query) =>
    Object.keys(query)
        .map((key) => encodeQueryPair(query, key))
        .join('/');

export const createSerpLink = (serpUrl, params) =>
    serpUrl.match(SITES.VRBO)
        ? `${serpUrl}&${encodeParams(params)}`
        : `${serpUrl}/${encodeQuery(params)}`;

const vrboSerpUrl = (domain, query) => {
    let queryUrl = {
        q: query.keywords
    };

    if (query.arrival && query.departure) {
        queryUrl['from-date'] = query.arrival;
        queryUrl['to-date'] = query.departure;
    }

    return url.format({
        pathname: `https://${domain}/results`,
        query: queryUrl
    });
};

const homeawaySerpUrl = (domain, query) =>
    `https://${domain}/results/${encodeQuery(query)}`;

export const encodeSerpUrl = (domain, query) =>
    domain.match('vrbo')
        ? vrboSerpUrl(domain, query)
        : homeawaySerpUrl(domain, query);
